/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BannedCommunity } from './BannedCommunity';
import {
    BannedCommunityFromJSON,
    BannedCommunityFromJSONTyped,
    BannedCommunityToJSON,
    BannedCommunityToJSONTyped,
} from './BannedCommunity';

/**
 * 
 * @export
 * @interface GetBannedCommunitiesResponse
 */
export interface GetBannedCommunitiesResponse {
    /**
     * 
     * @type {Array<BannedCommunity>}
     * @memberof GetBannedCommunitiesResponse
     */
    bannedCommunities: Array<BannedCommunity>;
}

/**
 * Check if a given object implements the GetBannedCommunitiesResponse interface.
 */
export function instanceOfGetBannedCommunitiesResponse(value: object): value is GetBannedCommunitiesResponse {
    if (!('bannedCommunities' in value) || value['bannedCommunities'] === undefined) return false;
    return true;
}

export function GetBannedCommunitiesResponseFromJSON(json: any): GetBannedCommunitiesResponse {
    return GetBannedCommunitiesResponseFromJSONTyped(json, false);
}

export function GetBannedCommunitiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBannedCommunitiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'bannedCommunities': ((json['bannedCommunities'] as Array<any>).map(BannedCommunityFromJSON)),
    };
}

export function GetBannedCommunitiesResponseToJSON(json: any): GetBannedCommunitiesResponse {
    return GetBannedCommunitiesResponseToJSONTyped(json, false);
}

export function GetBannedCommunitiesResponseToJSONTyped(value?: GetBannedCommunitiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bannedCommunities': ((value['bannedCommunities'] as Array<any>).map(BannedCommunityToJSON)),
    };
}

